import styled from 'styled-components';

export const StyledBanner = styled.div`
  background: ${({ theme }) => theme.colors.brand[800]};
  padding: 8px 16px;
  /* matches the spacing the page already gives the Simple Search block below */
  margin-top: 16px;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
`;

// Column flow fills both rows of a column before moving right, which pairs the
// parameters as the frame groups them and leaves LTV alone in the last column.
// Every item from the third on starts a new column, so those carry the divider.
export const StyledParams = styled.div`
  display: grid;
  grid-template-rows: auto auto;
  grid-auto-flow: column;
  justify-content: start;
  row-gap: 2px;

  > :nth-child(-n + 2) {
    padding-left: 0;
  }

  > :nth-child(n + 3) {
    border-left: 1px dashed ${({ theme }) => theme.colors.brand[200]};
  }
`;

export const StyledParam = styled.div`
  display: flex;
  align-items: baseline;
  gap: 12px;
  padding: 0 16px;
`;
